import type { Job, JobStatus as NumericJobStatus, JobStepStatus } from '../../app/ApiGen';
import { JobStatus } from '../../app/enums';
import { Normalised } from '../request';
import { isCommissioningFinished, isStageFinished } from './stages';

function isStepCompleted(status: JobStepStatus): boolean {
  return status === 'N/A' || status === 'completed' || status === 'manually completed';
}

export const jobEditable = (jobStatus?: NumericJobStatus): boolean =>
  jobStatus !== JobStatus.Commissioning && jobStatus !== JobStatus.Complete;

export function canUpdateJobStatus(args: {
  isEvnexAdmin: boolean;
  job: Pick<Normalised<Job>, 'details' | 'status'>;
}): boolean {
  const { isEvnexAdmin, job } = args;

  if (!isEvnexAdmin) {
    return job.status === JobStatus.Pending || job.status === JobStatus.Error;
  }

  const { installationStages } = job.details;
  if (job.status === JobStatus.InProgress && installationStages) {
    return (
      isStageFinished(installationStages.preWorkForm.status) &&
      isCommissioningFinished(installationStages) &&
      isStageFinished(installationStages.postWorkForm.status)
    );
  }

  if (job.status === JobStatus.InProgress && job.details.progress) {
    return (
      isStepCompleted(job.details.progress.preWorkForm) &&
      isStepCompleted(job.details.progress.commissioning) &&
      isStepCompleted(job.details.progress.postWorkForm)
    );
  }

  return job.status === JobStatus.Pending || job.status === JobStatus.Commissioning || job.status === JobStatus.Error;
}
